export default "__VITE_ASSET__Dt3m9Iui__"